const USERNAME_PATTERN = /^[A-Za-z0-9_]+$/;

const RESERVED_NAMES = new Set([
  "admin",
  "administrator",
  "leaderboard",
  "moderator",
  "official",
  "speedscuba",
  "support",
  "system",
]);

const EXACT_BLOCKED = new Set(["ass"]);

const CONTAINED_BLOCKED = [
  "bitch",
  "cock",
  "cunt",
  "dick",
  "fuck",
  "hitler",
  "nazi",
  "pussy",
  "shit",
  "slut",
  "whore",
];

export function validateUsername(value) {
  if (typeof value !== "string") {
    return invalid();
  }

  const username = value.trim();
  const usernameNormalized = username.toLowerCase();

  if (username.length < 3 || username.length > 18) {
    return invalid();
  }

  if (!USERNAME_PATTERN.test(username)) {
    return invalid();
  }

  if (RESERVED_NAMES.has(usernameNormalized)) {
    return invalid();
  }

  const profanityKey = normalizeForProfanity(usernameNormalized);
  if (
    EXACT_BLOCKED.has(profanityKey) ||
    CONTAINED_BLOCKED.some((term) => profanityKey.includes(term))
  ) {
    return invalid();
  }

  return {
    ok: true,
    username,
    usernameNormalized,
  };
}

function normalizeForProfanity(value) {
  return value
    .replaceAll("0", "o")
    .replaceAll("1", "i")
    .replaceAll("3", "e")
    .replaceAll("4", "a")
    .replaceAll("5", "s")
    .replaceAll("7", "t")
    .replaceAll("_", "");
}

function invalid() {
  return {
    error: "That username is not allowed.",
    ok: false,
  };
}
